import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { memo, useState } from 'react';
import InlineEditor from '../../../components/InlineEditor/InlineEditor';

type InputOptionProps = {
    value: string;
    label: string;
    tooltip: string;
    tooltipId: string;
    onConfirm: (newVal: string) => void;
    onValidate: (newVal: string) => { error?: string; info?: string; };
    onBeforeValidate?: (newVal: string) => boolean;
    className?: string;
    prefix?: string;
    width?: string;
}

export const InputOption = memo(({ className, value, label, tooltip, tooltipId, onConfirm, onValidate, onBeforeValidate, prefix, width }: InputOptionProps) => {

    const [editMode, setEditMode] = useState(false);

    const onEnterEditModeCb = React.useCallback(() => {
        setEditMode(true);
    }, []);

    const onLeaveEditModeCb = React.useCallback(() => {
        setEditMode(false);
    }, []);

    const addPx = prefix === 'px';

    const style = {} as any;

    if (width) {
        style.width = `${width}`;
        style.minWidth = `${width}`;
        style.maxWidth = `${width}`;
    }

    return <div className="text-chat-options_table_row">
        <div className={`text-chat-options_font-size ${className} ${editMode && 'in-edit-mode'}`}>
            <span className={addPx ? "text-chat-options_font-size_label" : "text-chat-options_label"}
                data-place="bottom"
                data-multiline="true"
                data-effect="solid"
                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
                data-for={tooltipId}
                data-tip={tooltip}>{label}</span>
            <ReactTooltip id={tooltipId} />
            <div
                className={addPx ? "text-chat-options_font-size_input-wrapper" : "text-chat-options_input-wrapper"}
                style={style}>
                <InlineEditor
                    key={value}
                    withBorder={true}
                    value={value}
                    readOnly={false}
                    autoFocus={true}
                    onEnterEditMode={onEnterEditModeCb}
                    onLeaveEditMode={onLeaveEditModeCb}
                    validate={onValidate}
                    beforeChangeValidation={onBeforeValidate}
                    exitEditModeAfterConfirm={true}
                    confirmOnLeave={true}
                    confirmAction={onConfirm} />
            </div>
        </div>
    </div>;
})